import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3","key":"svg-0"}]]

const IconSpace = createReactComponent('outline', 'space', 'Space', __iconNode);

export default IconSpace;